import { backendClient } from '@/lib/api-client';
import { availableRoles } from '@/lib/permissions';
import type { Matter, MatterMember } from '@/types/base';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useState } from 'react';

interface UpdateMemberRoleProps {
  matter: Matter;
  member: MatterMember;
  onSuccess?: () => void;
}

const UpdateMemberRole = ({ matter, member, onSuccess }: UpdateMemberRoleProps) => {
  const { t } = useTranslation('common');
  const [isUpdating, setIsUpdating] = useState(false);

  const updateRole = async (role: string) => {
    setIsUpdating(true);
    try {
      await backendClient.patch(`/matter/${matter.guid}/members/${member.user_guid}/role`, {
        role,
      });

      toast.success(t('member-role-updated'));
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Error updating role:', error);
      toast.error(t('error-updating-role'));
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Select
      defaultValue={member.role}
      onValueChange={updateRole}
      disabled={isUpdating}
    >
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder={member.role} />
      </SelectTrigger>
      <SelectContent>
        {availableRoles.map((role) => (
          <SelectItem key={role.name} value={role.name}>
            {role.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default UpdateMemberRole;
